import React from 'react';
import PropTypes from 'prop-types';
import { BadgeV2 } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { Product } from 'src/models';

import './ProductStatusStyle.scss';

const getChipType = (status) => {
  switch (status) {
    case Product.STATUS_COMPLETED:
      return 'success';
    case Product.STATUS_PENDING:
      return 'info';
    default:
      return '';
  }
};

const ProductStatusComponent = ({ row }) => {
  const { status } = row.values || {};

  return (
    <BadgeV2
      hoverable={false}
      className="product-status-badge"
      type={getChipType(status)}
    >
      <Message message={Product.getStatusMessage(status)} />
    </BadgeV2>
  );
};

ProductStatusComponent.propTypes = {
  row: PropTypes.object.isRequired,
};

export default ProductStatusComponent;
